import { Navigation } from "./Navigation/Navigation.js";
import { Dots } from "./Dots/Dots.js";
import { Sync } from "./Sync/Sync.js";
export var Plugins = {
  Navigation: Navigation,
  Dots: Dots,
  Sync: Sync
};